import React from "react";
import {
  Alert,
  Button,
  CircularProgress,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Typography,
} from "@mui/material";
import type { AiCommand } from "@/types/command";

interface Props {
  open: boolean;
  target: AiCommand | null;
  isPending: boolean;
  isError: boolean;
  onClose: () => void;
  onConfirm: (commandName: string) => void;
}

const ResetCommandDialog: React.FC<Props> = ({
  open,
  target,
  isPending,
  isError,
  onClose,
  onConfirm,
}) => {
  return (
    <Dialog open={open} onClose={onClose} maxWidth="xs" fullWidth>
      <DialogTitle>Reset Command</DialogTitle>
      <DialogContent>
        <Typography>
          Reset <strong>{target?.name}</strong> to default?
        </Typography>
        {isError && (
          <Alert severity="error" sx={{ mt: 2 }}>
            Failed to reset command.
          </Alert>
        )}
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose} disabled={isPending}>
          Cancel
        </Button>
        <Button
          variant="contained"
          color="warning"
          onClick={() => target && onConfirm(target.name)}
          disabled={isPending || !target}
          startIcon={isPending ? <CircularProgress size={18} color="inherit" /> : undefined}
        >
          {isPending ? "Resetting..." : "Reset"}
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default ResetCommandDialog;
